import React from 'react';
import { Typography } from '@material-ui/core';

import { RenderHtml } from 'components/RenderHtml';
import { Challenge } from 'generated/graphql';
import Img from 'retired/Img';
import BoxComponent from 'retired/Box';
import DialogButton from 'retired/DialogButton';

interface ChallengeImageBoxProps {
  challenge: Challenge;
  onEditDetails: () => void;
}

export const ChallengeImageBox = ({ challenge, onEditDetails }: ChallengeImageBoxProps) => {
  return (
    <BoxComponent style={{ padding: 0, marginBottom: 40 }}>
      {challenge.backgroundImage ? (
        <Img
          src={challenge.backgroundImage}
          alt="Challenge background"
          aspectRatio={16 / 9}
          style={{
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
          }}
        />
      ) : (
        <div
          style={{
            aspectRatio: '16 / 9',
            backgroundColor: '#f5f5f5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
          }}
        >
          <Typography
            style={{
              color: '#999',
              fontSize: 16,
              fontWeight: 400,
            }}
          >
            No challenge image set yet
          </Typography>
        </div>
      )}
      <div style={{ padding: 25 }}>
        <div style={{ textAlign: 'right', marginTop: 20 }}>
          <DialogButton
            text={
              challenge.totalText ? (
                <div>
                  <Typography component="h3" style={{ fontSize: 14, fontWeight: 500 }}>
                    Description
                  </Typography>
                  <Typography component="p" style={{ fontSize: 15, fontWeight: 300 }}>
                    <RenderHtml source={{ html: challenge.totalText }} />
                  </Typography>
                </div>
              ) : (
                <Typography component="p" style={{ fontSize: 15, fontWeight: 300 }}>
                  No description available.
                </Typography>
              )
            }
            buttonLabel="View Description"
            confirmLabel="Edit Details"
            cancelLabel="Back"
            handleConfirm={onEditDetails}
          />
        </div>
      </div>
    </BoxComponent>
  );
};
